import { render, staticRenderFns } from "./PerformanceMetrics.vue?vue&type=template&id=82622628&scoped=true&"
import script from "./PerformanceMetrics.vue?vue&type=script&lang=ts&"
export * from "./PerformanceMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceMetrics.vue?vue&type=style&index=0&id=82622628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82622628",
  null
  
)

export default component.exports